import type { Pattern } from "../types.js";

/**
 * REAL CONTENT — Enneatype 1. Replaces FAKE_PATTERN_1.
 *
 * Source: `docs/canonical/Especificacion_canonica_v1.1_y_plantilla_maestra.docx`,
 * section 11 «Eneatipo 1 — aplicación provisional», Bloque A. Built there from
 * Vilaseca (chapter "Eneatipo 1") plus the project blog, with every field
 * carrying its provenance tag — [FUENTE PROYECTO], [PROPUESTA], [INFERENCIA],
 * [HIPÓTESIS], [LÍMITE].
 *
 * ENGLISH, because the app ships in English (decision of 16 Aug 2026). The
 * canonical spec is Spanish, and translating a pattern formulation is not the
 * same as translating copy — the formulation IS the instrument. So the Spanish
 * original travels next to every field below: the translation stays reviewable
 * without opening the .docx, which is what traceability means here.
 *
 * STILL PROVISIONAL, and the spec says so itself: section 11 is a test
 * application of the master template, and section 15 lists what to settle
 * before treating it as a base for nine patterns. What is NOT provisional is
 * that it beats `[FAKE] Contenido de prueba — no usar como fuente`.
 *
 * `confusablePatterns` lists only patterns that exist in the alpha. The real
 * canonical list is wider — types 3 (demand aimed at results), 6 (vigilance and
 * error anticipation) and 8 (same instinctive triad, latent anger, control) —
 * and it is kept here in writing for the increment that widens past 1 and 9.
 * Pointing the result screen at a type that does not exist would be the same
 * dead end as a door that leads to a waiting list.
 */
export const PATTERN_1: Pattern = {
  id: "1",
  number: 1,
  // «el corrector» — Vilaseca usa "el reformador"; el blog, "the Perfectionist".
  workingName: "The corrector (working name)",
  // «Patrón organizado alrededor de la corrección: la atención se dirige primero
  //  a lo que está mal o incompleto, con sensación de obligación personal de
  //  arreglarlo»
  shortHypothesis:
    "A pattern organised around correction: attention goes first to what is " +
    "wrong or unfinished, together with a sense of personal obligation to fix it.",
  // «Autoexigencia, crítica interna, enfado por imperfección no resuelta,
  //  dificultad para relajarse ante un error propio o ajeno»
  whatItExplains:
    "Self-demand, inner criticism, anger at unresolved imperfection, and " +
    "difficulty relaxing in the face of a mistake — your own or someone else's.",
  // «El contenido concreto de lo que cada persona considera "correcto" (varía por
  //  educación, profesión, cultura); por qué una persona valora la corrección
  //  más que otra»
  whatItDoesNotExplain:
    "What any given person actually counts as “correct” — that varies " +
    "with upbringing, profession and culture — or why one person values " +
    "correctness more than another does.",
  // «Que la persona se defina de forma permanente como "perfeccionista" y use la
  //  etiqueta para justificar la rigidez en vez de observarla»
  identityRisk:
    "That you settle permanently into “I'm a perfectionist” and use the " +
    "label to justify the rigidity instead of watching it.",
  // Corregido el 16 ago: estaba a ["9"] porque el 9 era el único patrón
  // activo, pero el canon NO lista el 9 entre los confundibles del 1 — los
  // eligió como opuestos. Con el 6 en el alfa ya se puede poner lo que la
  // fuente dice: de 3, 6 y 8, el 6 es el que existe.
  confusablePatterns: ["6"],
  sourceRefs: [
    "Especificacion_canonica_v1.1_y_plantilla_maestra.docx §11, Bloque A",
    "Vilaseca, chapter “Eneatipo 1” — [FUENTE PROYECTO]",
    "Project blog, “1-the-perfeccionist” — [LÍMITE] source quality flagged in §8",
    "Working name and short formulation are [PROPUESTA], not established fact"
  ],
  contentVersion: "canon-1.1"
};
